import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { ChildEvent, ScrBaseComponent } from 'src/app/components/base.component';
import { ConfirmationService } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { ConfigService, PartnerService } from '../../../../services';
import { Partner } from '../../../../models/partner.model';
import { ChipsAddEvent } from 'primeng/chips';
import { PartnerType } from '../../../../models/constants';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  selector: 'app-add-partner',
  templateUrl: './add-partner.component.html',
  styleUrls: ['./add-partner.component.scss']
})
export class AddPartnerComponent extends ScrBaseComponent implements OnInit {


  public model = new Partner();
  public isDisplay = false;
  public legalEntityTypes: string[] = [];
  public publicEmailDomains: string[] = [];
  submitted = false;
  public errorMap = new Map<string, string>();


  //  form1!: UntypedFormGroup;
  @ViewChild('form1', { static: false }) form1!: NgForm;
  @Output() emitAction = new EventEmitter<ChildEvent>();
  dynamicMask!: string;

  @Input() partnerType!: PartnerType;
  public partnerTypeWithSpace = 'Brand Client';
  public partnerTypeShort = 'Brand';


  constructor(private configService: ConfigService,
    private partnerService: PartnerService,
    private confirmService: ConfirmationService) {
    super();

  }

  ngOnInit(): void {

    if (this.partnerType === PartnerType.Brand) {
      this.partnerTypeWithSpace = 'Brand Client';
      this.partnerTypeShort = 'Brand';
    }
    else {
      this.partnerTypeWithSpace = 'Content Provider';
      this.partnerTypeShort = 'Content Provider';
    }

    this.configService.getConfig().subscribe(cfg => {
      this.legalEntityTypes = cfg.legalEntityTypes;
      this.publicEmailDomains = cfg.excludedPublicEmailDomains;

    });

    this.model.country = 'us';
    this.isDisplay = true;
  }


  savePartner({ form }: NgForm) {
    this.clearMessages();
    form.markAllAsTouched();
    for (const name in form.controls) {
      form.controls[name].markAsDirty();
    }

    if (form.invalid) {
      this.submitted = true;
      this.scrollToFirstError();
    } else {

      const prunedData = this.removeEmpty(form.value);
      const formData = JSON.parse(JSON.stringify(prunedData), this.prepareForSubmit);
      formData.subsidiaries = formData.subsidiaries?.join('^') || null;
      formData.partnerType = this.partnerType;

      this.observe(this.partnerService.savePartner(formData), res => {
        if (res.messages && res.messages.length > 0) {
          this.emitAction.emit({ action: 'reload', value: res.partner?.partnerId, message: res.messages[0].message });
        }
        else {
          this.emitAction.emit({ action: 'reload', value: res.partner?.partnerId, messageCode: 'scr.cc.updated' });

        }
        return false;
      });
    }
  }



  removeEmpty(obj: Record<string, unknown> | ArrayLike<unknown>) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != ''));
  }

  prepareForSubmit(key: string, value: string | number | boolean) {

    if (typeof value === 'string') {

      return value.trim();
    }
    return value;
  }





  confirmCancelDialog() {
    this.confirmService.confirm({
      key: 'confirmCancel',
      header: 'Confirm Cancellation',
      message: 'Are you sure you want to cancel the request?',
      accept: () => {
        this.form1.reset();
        this.submitted = false;
        this.emitAction.emit({ action: 'cancel', value: 'cancel' });
      },
      reject: () => {
        this.confirmService.close();
      }
    });
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }

  validateChipFormat(event: ChipsAddEvent) {
    if (event.value.includes('^')) {
      this.model.subsidiaries?.pop();
    }
  }

  onChangeDropdown(event: DropdownChangeEvent) {
    if (!event.value)
      this.model.legalEntityType = undefined;
  }

}
